import { State, Product, Size } from './types';

export const emptyProduct: Product = {
  productRef: '',
  productName: '',
  productDescription: '',
  productComposition: '',
  status: false,
  eReservation: false,
  colorRef: '',
  colorLabel: '',
  detailedColorLabel: '',
  realColorRef: '',
  collectionName: '',
  cleaningAdvice: '',
  originalPrice: 0,
  storePrice: 0,
  promotionPercentage: '',
  promotionLabel: '',
  contentRecycledMaterials: 0,
  recyclability: false,
  rejectsMicrofibers: false,
  toxicity: false,
  traceability: '',
  hide_csr_block: false,
  images: [],
  categories: {
    lvl0: '',
    lvl1: '',
    lvl2: '',
    lvl3: '',
  },
  colorVariants: [],
  sizeVariants: [],
  model: [],
};

export const emptyProductModal: Product = {
  productRef: '',
  productName: '',
  productDescription: '',
  productComposition: '',
  status: false,
  eReservation: false,
  colorRef: '',
  colorLabel: '',
  detailedColorLabel: '',
  realColorRef: '',
  collectionName: '',
  cleaningAdvice: '',
  originalPrice: 0,
  storePrice: 0,
  promotionPercentage: '',
  promotionLabel: '',
  contentRecycledMaterials: 0,
  recyclability: false,
  rejectsMicrofibers: false,
  toxicity: false,
  traceability: '',
  hide_csr_block: false,
  images: [],
  categories: {
    lvl0: '',
    lvl1: '',
    lvl2: '',
    lvl3: '',
  },
  colorVariants: [],
  sizeVariants: [],
  model: [],
};

export const emptySize: Size = {
  sku: '',
  originalPrice: 0,
  storePrice: 0,
  promotionPercentage: '',
  stockQuantity: 0,
  cupSize: '',
  bandSize: '',
  size: '',
  storesAvailable: [],
};

export const productState: State = {
  product: { ...emptyProduct },
  productModal: { ...emptyProductModal },
  isFetching: false,
  errMsg: '',
  size: { ...emptySize },
  sizeModal: { ...emptySize },
  sizeErrMsg: '',
  crossSellIsLoading: true,
  upSellIsLoading: true,
  yotpoBottomline: null,
  yotpoReviews: [],
};
